import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import pulsar200 from "../../images/pulsar-200.jpg";
import "../../../src/product.css";

const Pulsar200 = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">PULSAR 200cc</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={pulsar200}
              alt="Bajaj Pulsar 200cc"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              Pulsar 200 takes your Pulsar experience to an all new level. A
              bike crafted for seeking adventure every day. Combined with the
              World’s 1st 4 Valve, Triple Spark DTSi Engine, Pulsar 200 is
              designed to thrill with its superior technology and street
              fighter looks.
            </p>

          </div>
        </section>

        {/* Specifications */}
        <section className="product-specifications">

          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Engine Type</span>
              <strong>4 Stroke Engine</strong>
            </div>

            <div className="spec-card">
              <span>Cubic Capacity</span>
              <strong>199.5 cc</strong>
            </div>

            <div className="spec-card">
              <span>Transmission</span>
              <strong>Manual</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Type</span>
              <strong>Petrol</strong>
            </div>

            <div className="spec-card">
              <span>Battery</span>
              <strong>12V</strong>
            </div>

            <div className="spec-card">
              <span>Weight</span>
              <strong>152 kg</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Pulsar200;